import { Component, OnInit } from '@angular/core';
import { Notification } from '../interfaces/notification.interface';
import { DateTime } from 'luxon';
import { trackById } from '../../../../utils/track-by';

@Component({
  selector: 'vex-toolbar-notifications-dropdown',
  templateUrl: './toolbar-notifications-dropdown.component.html',
  styleUrls: ['./toolbar-notifications-dropdown.component.scss']
})
export class ToolbarNotificationsDropdownComponent implements OnInit {

  notifications: Notification[] = [
    {
      id: '1',
      label: 'به آخر هفته نزدیک شدیم',
      icon: 'mat:shopping_basket',
      colorClass: 'text-primary',
      datetime: '30 دقیقه پیش'
    },
    {
      id: '2',
      label: 'سوال باشناسه 7 دارای گزارش مخرب میباشد',
      icon: 'mat:account_circle',
      colorClass: 'text-orange',
      datetime: 'دو ساعت پیش'
    },
    {
      id: '3',
      label: 'در این هفته 120 گیمر ثبت نام داشتند',
      icon: 'mat:insert_chart',
      colorClass: 'text-purple',
      datetime:'5ساعت پیش'
    },
 
  ];

  trackById = trackById;

  constructor() { }

  ngOnInit() {
  }
  ReadAll():void{
this.notifications=[]
  }
}
